/**
 * Payment Methods Checker
 * Step 1: MutationObserver to check modal state and payments data content
 */

(function() {
  'use strict';

  // Payment method values
  const PAYMENT_CASH_ON_DELIVERY = '0';
  const PAYMENT_CARD = '1';

  // Cart conditions - initialized to false
  let hasGiftCard = false;
  let hasEngraving = false;
  let isSendAsGift = false;
  
  // Payment update flag - initialized to false
  let shouldUpdatePayment = false;

  // Modal heading update flag - initialized to false
  let shouldUpdateModalHeading = false;

  let modalObserver = null;

  /**
   * Checks if cart items contain a gift card
   */
  function checkForGiftCard(cartItems) {
    return cartItems.some(item => {
      return item.gift_card;
    });
  }

  /**
   * Checks if cart items contain engraving
   */
  function checkForEngraving(cartItems) {
    return cartItems.some(item => {
      return item.properties && item.properties.engraving;
    });
  }

  /**
   * Checks if cart attributes contain send as gift flag
   */
  function checkForSendAsGift(cart) {
    return cart.attributes['Send as Gift'] === 'Yes';
  }

  /**
   * Updates payment method based on conditions
   */
  function updatePaymentMethod(shouldUpdatePayment) {
    const paymentsDataElement = document.getElementById('mw-payments-data');
    if (!paymentsDataElement) {
      return;
    }

    const cashOnDeliveryRadio = paymentsDataElement.querySelector('input[type="radio"][value="' + PAYMENT_CASH_ON_DELIVERY + '"]');
    const cardRadio = paymentsDataElement.querySelector('input[type="radio"][value="' + PAYMENT_CARD + '"]');
    
    const cashOnDeliveryDiv = cashOnDeliveryRadio.closest('.mw-payments-choose');
    const cardDiv = cardRadio.closest('.mw-payments-choose');
    
    if (!cashOnDeliveryRadio || !cardRadio) {
      return;
    }

    cashOnDeliveryDiv.classList.remove('hidden');

    // If condition is true and cash on delivery is selected, switch to card
    if (shouldUpdatePayment) {
      cashOnDeliveryRadio.checked = false;
      cardRadio.checked = true;
      
      // Update parent div classes      
      cashOnDeliveryDiv.classList.remove('mw-payments-selected');
      cashOnDeliveryDiv.classList.add('hidden');
      cardDiv.classList.add('mw-payments-selected');

      // Trigger change event on the card radio button
      cardRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /**
   * Updates payment method based on conditions
   */
  function updateModalHeading(shouldUpdateModalHeading) {
    const modalHeading = document.querySelector('.mw-client-info #mw-ci-text');

    if (!modalHeading) {
      return;
    }

    const recipientDetails = window.theme.strings.cart.recipient_details;
    const yourDetails = window.theme.strings.cart.your_details;

    modalHeading.textContent = shouldUpdateModalHeading ? recipientDetails : yourDetails;
  }

  /**
   * Fetches cart data and updates conditions
   * @param {boolean} shouldUpdatePayment - Flag to determine if payment method should be updated
   */
  function fetchCart(shouldUpdatePayment) {
    const routes = window.theme && window.theme.routes && window.theme.routes.cart || {};
    const cartUrl = (routes.base || '/cart') + '.js';

    return fetch(cartUrl, {
      method: 'GET',
      credentials: 'include'
    })
    .then(response => response.json())
    .then(cart => {
      hasGiftCard = checkForGiftCard(cart.items || []);
      hasEngraving = checkForEngraving(cart.items || []);
      isSendAsGift = checkForSendAsGift(cart);
      
      // Set shouldUpdatePayment to true if either condition is true
      if (hasGiftCard || hasEngraving || isSendAsGift) {
        shouldUpdatePayment = true;
      }

      // Set shouldUpdateModalHeading to true if either condition is true
      shouldUpdateModalHeading = isSendAsGift;

      // Use the updated global shouldUpdatePayment variable
      updatePaymentMethod(shouldUpdatePayment);

      // Use the updated global shouldUpdateModalHeading variable
      updateModalHeading(shouldUpdateModalHeading);
      
      return cart;
    })
    .catch(error => {
      console.error('[Payment Methods] Error fetching cart:', error);
      return null;
    });
  }

  /**
   * Sets up MutationObserver for mw-modal element
   */
  function setupModalObserver() {
    const modalElement = document.getElementById('mw-modal');
    
    if (!modalElement) {
      return;
    }

    // Create observer to watch for changes in the modal
    modalObserver = new MutationObserver(function(mutations) {
      // Check if modal is open (not display: none)
      const isModalOpen = modalElement.style.display !== 'none';

      if (isModalOpen) {
        // Modal is open, check if mw-payments-data has content
        const paymentsDataElement = document.getElementById('mw-payments-data');
        
        if (paymentsDataElement) {
          const hasContent = paymentsDataElement.children.length > 0;

          // If modal is open and has content, check for radio buttons
          if (hasContent) {
            const cashOnDeliveryRadio = paymentsDataElement.querySelector('input[type="radio"][value="' + PAYMENT_CASH_ON_DELIVERY + '"]');
            const cardRadio = paymentsDataElement.querySelector('input[type="radio"][value="' + PAYMENT_CARD + '"]');
            
            if (cashOnDeliveryRadio && cardRadio) {
              // Fetch cart and update payment method based on conditions
              fetchCart(shouldUpdatePayment);
            }
          }
        }
      }
    });

    // Start observing the modal for attribute and style changes
    modalObserver.observe(modalElement, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupModalObserver();
    });
  } else {
    setupModalObserver();
  }

  // Also check on window load as backup
  window.addEventListener('load', function() {
    if (!modalObserver) {
      setupModalObserver();
    }
  });

})();
